import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutPbwLoadboardServices extends Layout {
    sourcePbwLoadboardServices: DataSource;
    tablePbwLoadboardServices: Table;
}
